import { JOURNAL_FILTERS } from './models'

const reducers = {
  setJournalFilters: (state, action) => { state[JOURNAL_FILTERS] = action.payload },
}

export default reducers
